"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlert = exports.Alert = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const useAlert_1 = require("@reactionable/core/lib/ui/alert/useAlert");
const Alert_1 = tslib_1.__importDefault(require("react-bootstrap/Alert"));
const Icon_1 = require("../icon/Icon");
const Alert = (_a) => {
    var { children, icon } = _a, props = tslib_1.__rest(_a, ["children", "icon"]);
    return (jsx_runtime_1.jsxs(Alert_1.default, Object.assign({}, props, { children: [icon && jsx_runtime_1.jsx(Icon_1.Icon, Object.assign({ className: "mr-2" }, icon), void 0), children] }), void 0));
};
exports.Alert = Alert;
const useAlert = (props) => {
    return useAlert_1.useAlert(Object.assign({ Component: exports.Alert }, props));
};
exports.useAlert = useAlert;
//# sourceMappingURL=Alert.js.map